import { render, staticRenderFns } from "./inspectionSverka.vue?vue&type=template&id=16b142e2&scoped=true"
import script from "./inspectionSverka.vue?vue&type=script&lang=js"
export * from "./inspectionSverka.vue?vue&type=script&lang=js"
import style0 from "./inspectionSverka.vue?vue&type=style&index=0&id=16b142e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b142e2",
  null
  
)

export default component.exports